import { render } from "./FilesNotAcceptedModal.vue?vue&type=template&id=673066ca&scoped=true"
import script from "./FilesNotAcceptedModal.vue?vue&type=script&lang=js"
export * from "./FilesNotAcceptedModal.vue?vue&type=script&lang=js"

import "./FilesNotAcceptedModal.vue?vue&type=style&index=0&id=673066ca&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-673066ca"],['__file',"src/components/FilesNotAcceptedModal.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "673066ca"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('673066ca', __exports__)) {
    api.reload('673066ca', __exports__)
  }
  
  module.hot.accept("./FilesNotAcceptedModal.vue?vue&type=template&id=673066ca&scoped=true", () => {
    api.rerender('673066ca', render)
  })

}


export default __exports__